import $ from 'jquery';

function registerPopupHandler() {
  $(document).off('click', '.popup-link');
  $(document).on('click', '.popup-link', function () {
    const popupContainer = $(this).closest('.popup-container');
    const popupContent = popupContainer.find('.popup-body');

    const isOpen = popupContent.hasClass('show-popup');

    // Andere Popups schließen
    $('.popup-body.show-popup').each(function () {
      if (!$(this).is(popupContent)) {
        $(this).removeClass('show-popup');
      }
    });

    if (isOpen) {
      popupContent.removeClass('show-popup');
    } else {
      popupContent.removeClass('popup-left popup-up');

      const containerOffset = popupContainer.offset();
      const containerWidth = popupContent.outerWidth();
      const windowWidth = $(window).width();
      const windowHeight = $(window).height();
      const threshold = 21;

      if (containerOffset.left + containerWidth > windowWidth - threshold) {
        popupContent.addClass('popup-left');
      }

      const popupBottom = containerOffset.top + popupContent.outerHeight();
      const spaceAbove = containerOffset.top;
      const spaceNeededAbove = 1500;

      if (
        popupBottom > windowHeight - threshold &&
        spaceAbove > spaceNeededAbove
      ) {
        popupContent.addClass('popup-up');
      }

      popupContent.addClass('show-popup');
    }

  });
}

registerPopupHandler();
document.addEventListener('turbo:load', registerPopupHandler);
